import { Component, DestroyRef, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common'; 
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatInputModule } from '@angular/material/input'; 
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox'; // ➔ 1. importを追加

// import { Addresses, AddressesFormComponent, AddressesDefaultValue } from '../addresses-form/addresses-form.component';
import { BillingInfo, BillingInfoDefaultValue, BillingInfoFormComponent } from './billing-info-form.component';
import { SectionGroupContractChannel } from '../../../constants/app-constants';
import { DistributorDocument } from '../../admin-system/distributor-details/distributor-details.component';
import { GetDistributorService } from "../../../data/distributor/get-distributor.service";
import { SECTION_GROUP_CONTRACT_CHANNEL } from '../../../constants/app-constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SectionGroupDocument } from '../../admin-system/section-group-details/section-group-details.component';
import { BillingSource, BillingSourceDefaultValue, BillingSourceFormComponent } from './billing-source-form/billing-source-form.component';
import { BillingTerms, BillingTermsDefaultValue, BillingTermsFormComponent } from './billing-terms-form/billing-terms-form.component';
import { DebugUtils } from 'src/app/shared/utils/debug-utils';

@Component({
  selector: 'app-sg-billing-info-form',
  templateUrl: './section-group-billing-info-form.component.html',
  imports: [
    BillingSourceFormComponent,
    BillingTermsFormComponent,

    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
})
export class SgBillingInfoFormComponent implements OnInit{
  
  @Input() sgBillingInfoForm!: FormGroup;
  @Input() sectionGroupData!: SectionGroupDocument;
  // @Input() distributors!: DistributorDocument[];
  
  @ViewChild('billingSourceFormComp') billingSourceFormComponent!: BillingSourceFormComponent;

  public sectionGroupContractChannel = SECTION_GROUP_CONTRACT_CHANNEL;

  distributor = signal<DistributorDocument | null>(null); // 契約チャネルが代理店経由のときに代理店の名前を表示するために使用する
  distributors: DistributorDocument[] | undefined;

  private destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
  ) {}

  ngOnInit(){
  }

  // setChangeEvents() {
  //   const contractChannelControl = this.sgBillingInfoForm.get('contractChannel');
  
  //   if (contractChannelControl) {
  //     contractChannelControl.valueChanges
  //       .pipe(takeUntilDestroyed(this.destroyRef)) // 💡コンポーネント破棄時に自動クリーンアップ
  //       .subscribe((value: string) => {
  //         // 初期値の代入時にも実行される
  //         // ユーザーがクリックして変更した時も、ここが走る
  //         this.onContractChannelChange(value);
  //       });

  //     // フォーム作成時の既定値で一度実行しておく
  //     this.onContractChannelChange(contractChannelControl.value);
  //   }

  //   const hasCustomBillingRuleControl = this.sgBillingInfoForm.get('hasCustomBillingRule');
  
  //   if (hasCustomBillingRuleControl) {
  //     hasCustomBillingRuleControl.valueChanges
  //       .pipe(takeUntilDestroyed(this.destroyRef)) // 💡コンポーネント破棄時に自動クリーンアップ
  //       .subscribe((checked: boolean) => {
  //         // 初期値の代入時にも実行される
  //         // ユーザーがクリックして変更した時も、ここが走る
  //         this.onHasCustomBillingRuleChange(checked);
  //       });

  //     // フォーム作成時の既定値で一度実行しておく
  //     this.onHasCustomBillingRuleChange(hasCustomBillingRuleControl.value);
  //   }
  // }

  // getDistributor(distributorId: string | undefined){
  //   if (!distributorId){
  //     return;
  //   }

  //   this.getDistributorService.getDistributor(distributorId)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe({
  //       next: (res) => {
  //         this.distributor.set(res as any);
  //       },
  //       error: (error) => {
  //         console.error(error);
  //       }
  //     });
  // }


  
  public onContractChannelChange(channel: string): void {
    console.log("contract channel", channel);

    if (channel === 'DISTRIBUTOR') {
      // DISTRIBUTOR の場合は、両方のグループを非活性にする
      // this.sgBillingInfoForm?.get("billingSource")?.disable();
      // this.sgBillingInfoForm?.get("billingTerms")?.disable();
      // console.log("billingSource/Terms disabled");
    } else {
      // DIRECT などの場合は活性化する
      // this.sgBillingInfoForm?.get("billingSource")?.enable();
      // this.sgBillingInfoForm?.get("billingTerms")?.enable();

      this.onHasCustomBillingRuleChange(this.sgBillingInfoForm.get('hasCustomBillingRule')?.value);
    }
  }

  public onHasCustomBillingRuleChange(checked: boolean): void {
    console.log("onHasCustomBillingRuleChange", checked);

    if (checked){
      this.sgBillingInfoForm.get("billingSource")?.disable();
      this.sgBillingInfoForm.get("billingTerms")?.disable();
      console.log("billingSource/Terms disabled");
    }
    else{
      this.sgBillingInfoForm.get("billingSource")?.enable();
      this.sgBillingInfoForm.get("billingTerms")?.enable();
      console.log("billingSource/Terms enabled");

      this.billingSourceFormComponent?.onPaymentMethodChange(this.sgBillingInfoForm.get('billingSource.paymentMethod')?.value);
    }

  }


  public receiveDistributorsFromParentForm(distributors: DistributorDocument[]): void {
    this.distributors = distributors;

    const control = this.sgBillingInfoForm.get('billToDistributorId');

    // 画面上でドロップダウンの値を設定しなおす
    if (control){
      let isDisabled = control.disabled;

      const currentId = control.value;
      if (currentId) {
        //　元々 disabled だったときは一旦 enableしてから値をセットしないと画面上のドロップダウンの表示が更新されない
        if (isDisabled){
          control.enable();
        }
        control.setValue(currentId);
        //　元々 disabled だったときは元に戻してやる
        if (isDisabled){
          control.disable();
        }
      }

    }
  }

  getBillingTermsGroup(): FormGroup {
    return this.sgBillingInfoForm.get('billingTerms') as FormGroup;
  }

  getBillingSourceGroup(): FormGroup {
    return this.sgBillingInfoForm.get('billingSource') as FormGroup;
  }

  

  static createSgBillingInfoGroup(): FormGroup {
    const baseGroup = BillingInfoFormComponent.createBillingInfoGroup();

    return new FormGroup({
      ...baseGroup.controls,
      contractChannel:  new FormControl("DIRECT"),
      billToDistributorId:  new FormControl(null),
    })
  }
}


export interface SgBillingInfo extends BillingInfo {
  contractChannel: SectionGroupContractChannel,
  billToDistributorId: string | null,
}
export const SgBillingInfoDefaultValue : SgBillingInfo = {
  ...BillingInfoDefaultValue,
  contractChannel: "DIRECT",
  billToDistributorId: null,
}